export default function PrivacyPolicy() {
  return (
    <div className="bg-darkerBlue text-primaryBlack min-h-screen px-4 py-10">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-primaryOrange mb-6">Privacy Policy</h1>

        <p className="mb-2 text-sm italic text-primaryGray">Effective Date: April 2, 2025</p>

        <p className="mb-4">
          Welcome to <strong>Greetli</strong>! We are a mobile app dedicated to offering
          personalized information and professional assistance for individuals moving to or living in Switzerland.
        </p>

        <p className="mb-4">
          Our service is tailored to your profile, considering factors like country of origin, status, and canton, to provide you with the most relevant information and services for your life in Switzerland.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Disclaimer</h2>
        <p className="mb-4">
          <strong>Greetli is not a government agency and does not provide legal advice.</strong> All content and guidance provided in the app is for general informational purposes only. We do our best to ensure accuracy, but Greetli makes no guarantees regarding the completeness, timeliness, or outcomes of using this information. For legal or immigration-related matters, please consult an authorized professional or the appropriate Swiss authorities.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Data Collection and Use</h2>
        <p className="mb-4">
          To provide our personalized services, we collect the following information:
          Email Address, Password, Country of Origin, Status, and Canton Preferences. We use this data to:
        </p>
        <ul className="list-disc list-inside mb-4 space-y-2">
          <li>Personalize your experience with tailored information and services</li>
          <li>Connect you with the appropriate professionals and services</li>
          <li>Show you ads and offers for products that might be of interest to you</li>
        </ul>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Data Sharing</h2>
        <p className="mb-4">
          We may share your data with our partner companies so they may offer you their products and services. Additionally, when processing your order, we may send your data to and use the resulting information from credit reference agencies to prevent fraudulent purchases.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Security Measures</h2>
        <p className="mb-4">
          Your privacy and data security are paramount. We have implemented various security measures, including:
        </p>
        <ul className="list-disc list-inside mb-4 space-y-2">
          <li>Encryption</li>
          <li>Access Controls</li>
          <li>Regular Audits and Monitoring</li>
          <li>Data Anonymization</li>
          <li>Physical Security Measures</li>
          <li>Secure Development Practices</li>
          <li>Data Backup and Recovery</li>
          <li>Employee Training and Awareness</li>
        </ul>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Your Rights</h2>
        <p className="mb-4">
          You have the right to access, correct, or delete your personal information at any time. Should you wish to exercise these rights, please contact us through our website at{' '}
          <a href="https://www.greetli.ch" className="text-linkColor underline hover:text-darkOrange">
            www.greetli.ch
          </a>.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Changes to This Policy</h2>
        <p className="mb-4">
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Contact Us</h2>
        <p className="mb-4">
          If you have any questions or suggestions about our Privacy Policy or Terms of Use, do not hesitate to contact us at{' '}
          <a href="mailto:info@greetli.ch" className="text-linkColor underline hover:text-darkOrange">
            info@greetli.ch
          </a>.
        </p>

        <h1 className="text-3xl font-bold text-primaryOrange mt-16 mb-6">Terms of Use</h1>

        <p className="mb-2 text-sm italic text-primaryGray">Effective Date: April 2, 2025</p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Eligibility</h2>
        <p className="mb-4">
          You must be at least 16 years old to use the Greetli app. If you are under 18, you must have parental or guardian consent.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">User Responsibilities</h2>
        <p className="mb-4">
          As a user, you are responsible for all activities that occur under your account. You agree to use the app in compliance with all applicable laws and regulations.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Prohibited Conduct</h2>
        <p className="mb-4">
          You agree not to use the app for any unlawful, harmful, or fraudulent activities, including but not limited to:
        </p>
        <ul className="list-disc list-inside mb-4 space-y-2">
          <li>Uploading malicious content</li>
          <li>Harassing or impersonating others</li>
          <li>Engaging in unauthorized data collection</li>
          <li>Violating intellectual property rights</li>
        </ul>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Limitation of Liability</h2>
        <p className="mb-4">
          Greetli is not responsible for any damages or losses resulting from your use of the app, reliance on its content, or any errors or omissions. We do not guarantee any outcomes based on the information provided.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Termination</h2>
        <p className="mb-4">
          We reserve the right to suspend or terminate your access to the app at our discretion, particularly if you violate these Terms of Use.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Changes to Terms</h2>
        <p className="mb-4">
          We may update these Terms of Use from time to time. Continued use of the app after changes are posted indicates your acceptance of the updated terms.
        </p>

        <h2 className="text-xl font-semibold text-primaryOrange mt-8 mb-2">Governing Law</h2>
        <p className="mb-4">
          These Terms are governed by the laws of Switzerland. Any legal disputes shall fall under the jurisdiction of Swiss courts.
        </p>
      </div>
    </div>
  );
}